export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_FILTER = 'SET_FILTER';
export const SET_FILTERED = 'SET_FILTERED';
export const RESET_PRODUCT = 'RESET_PRODUCT';
